import CheckingShipshapeSection from './checking-shipshape-section';

export default CheckingShipshapeSection;
